export default "__VITE_ASSET__EbB84S6a__"